<div class="summary d-flex flex-column flex-md-row">

  <!-- Carrier -->
  <div class="col p-4 d-flex align-items-center" *ngIf="scacCode">
    <img *ngIf="hasLogo" class="carrier-logo me-3" [class.carrier-logo--wide]="scacCode === 'CMAU'"
         [class.carrier-logo--compact]="scacCode === 'HLCU'"
         [src]="logoPath" [alt]="carrierName">

    <div>
      <div class="label">Carrier:</div>
      <div class="value">{{ carrierName }}</div>
    </div>
  </div>


  <!-- Bill of Lading number -->
  <div class="col p-4 d-flex">
    <div class="brand-alpha">
      <svg class="me-3 mt-1" width="40" height="40">
        <use href="/assets/icons.svg#icon-view-document"></use>
      </svg>
    </div>

    <div>
      <div class="label" *ngIf="trackingResponse.type==='CARRIER_BOOKING_NUMBER'">Carrier Booking Number:</div>
      <div class="label" *ngIf="trackingResponse.type==='CONTAINER_NUMBER'">Container Number:</div>
      <div class="label" *ngIf="trackingResponse.type==='BILL_OF_LADING'">Bill of Lading Number:</div>
      <div class="value">{{trackingResponse.searchString}}</div>
    </div>
  </div>


  <!-- From -->
  <div class="col p-4 d-flex" *ngIf="trackingResponse.from">
    <div class="brand-alpha">
      <svg class="me-3 mt-2" width="40" height="40">
        <use href="/assets/icons.svg#icon-left"></use>
      </svg>
    </div>

    <div>
      <div class="label">From:</div>
      <div class="value">{{trackingResponse.from}}</div>
    </div>
  </div>


  <!-- To -->
  <div class="col p-4 d-flex" *ngIf="trackingResponse.to">
    <div class="brand-alpha">
      <svg class="me-3 mt-2" width="40" height="40">
        <use href="/assets/icons.svg#icon-right"></use>
      </svg>
    </div>

    <div>
      <div class="label">To:</div>
      <div class="value">{{trackingResponse.to}}</div>
    </div>
  </div>
</div>
